import React, {useState} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import {ButtonSecondaryHover, ButtonTextStyle, themeColors} from "./MUIStylePresets";
import {Typography} from "@mui/material";

// ---  ---
const NEWSLETTER_API_ENDPOINT = 'https://n8n.next-up.dev/webhook/a6221b40-be97-4c80-bb26-c1ece19cbd52';

function NewsletterSignup() {
    const [email, setEmail] = useState('');
    const [formError, setFormError] = useState(''); // For frontend validation errors
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' }); // 'success' or 'error'

    const validateEmail = (emailToValidate) => {
        if (!emailToValidate) {
            setFormError('Veuillez ajouter une adresse email');
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailToValidate)) {
            setFormError('Merci d\'entrer une adresse valide');
            return false;
        }
        setFormError('');
        return true;
    };

    const handleEmailChange = (event) => {
        const newEmail = event.target.value;
        setEmail(newEmail);
        if (formError) {
            validateEmail(newEmail); // Clear error on typing if valid
        }
        if (submitStatus.message) {
            setSubmitStatus({ type: '', message: '' }); // Clear previous submission status
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitStatus({ type: '', message: '' }); // Clear previous messages

        if (!validateEmail(email)) {
            return; // Don't submit if frontend validation fails
        }

        setIsSubmitting(true);

        try {
            // The body of the request will be a JSON object: { "email": "user@example.com" }
            const response = await axios.post(NEWSLETTER_API_ENDPOINT, {
                email: email,
            });
            console.log(response);

            // Assuming your API returns a success message or status
            console.log('Subscription successful:', response.data);
            setSubmitStatus({ type: 'success', message: 'Vous êtes maintenant abonné !' });
            setEmail(''); // Clear the field
            // Optionally, you could also clear formError here if it was set by a previous attempt
            // setFormError('');

        } catch (error) {
            console.error('Subscription error:', error);
            let errorMessage = 'Subscription failed. Please try again later.';
            if (error.response && error.response.data && error.response.data.message) {
                // If your API returns a specific error message in error.response.data.message
                errorMessage = error.response.data.message;
            } else if (error.request) {
                console.log(error.request);
                // The request was made but no response was received
                errorMessage = 'No response from server. Please check your connection.';
            }
            setSubmitStatus({ type: 'error', message: errorMessage });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box sx={{ maxWidth: 800, margin: '20px auto', mt:7 }}>
            <Stack
                component="form"
                onSubmit={handleSubmit}
                direction={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                spacing={{ xs: 2, sm: 4 }}
            >
                <TextField
                    label="Votre Email"
                    variant="outlined"
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={() => validateEmail(email)}
                    error={!!formError}
                    helperText={formError}
                    fullWidth
                    sx={{ flexGrow: 1 }}
                    disabled={isSubmitting}
                />
                <Button
                    type="submit"
                    disabled={isSubmitting || !email || !!formError}
                    variant={!formError && email ? "outlined" : "text"}
                    sx={{...ButtonSecondaryHover, textTransform: "none"}}
                >
                    {isSubmitting ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        <>
                            <Typography
                                variant={"book"}
                                sx={{ color: themeColors("primary") }}
                            >
                                S'abonner à la Newsletter
                            </Typography>
                        </>
                    )}
                </Button>
            </Stack>

            {/* Display Success or Error Messages */}
            {submitStatus.message && (
                <Alert severity={submitStatus.type} sx={{ mt: 2 }}>
                    {submitStatus.message}
                </Alert>
            )}
        </Box>
    );
}

export default NewsletterSignup;